<template>
    <div class="footer frame-padding">
        <div>
            <div class="footer__top">
                <div class="ms__logo">
                    <router-link to="/"> 
                        <img src="../assets/logo.svg" alt="">
                    </router-link>
                </div>
                <a href="https://vk.com/vk_stomat51?ysclid=mhxloa1gd6303514223" target="_blank">
                    <svg width="40" height="24" viewBox="0 0 27 17" fill="none"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.7499 6.68633V2.06637C15.7499 1.02512 15.5611 0.816376 14.5249 0.816376L11.5874 0.750126C10.6724 0.750126 10.2149 0.750126 10.0299 1.04637C9.84492 1.34262 10.0499 1.74887 10.4587 2.55886C10.6862 3.00886 10.8087 3.3351 10.8087 3.8401V7.16507C10.8087 8.21506 10.8087 8.74131 10.4087 8.89756C10.0087 9.05256 9.67743 8.70006 9.01243 7.99506C7.38744 6.26508 6.53994 4.1051 5.9837 1.75012C5.8687 1.26262 5.8112 1.01887 5.6387 0.883875C5.4662 0.748876 5.21995 0.750126 4.72996 0.750126H1.97997C1.37748 0.750126 1.07623 0.750126 0.887478 0.962625C0.699979 1.17637 0.736229 1.44887 0.808728 1.99262C1.46872 6.90132 5.78495 14.95 13.7587 15.7175C15.1711 15.8525 15.7499 15.4713 15.7499 13.9238C15.7499 13.0463 15.7311 11.6288 16.8349 11.4425C17.4136 11.345 17.8024 11.5513 18.4486 12.0925C19.5686 13.0325 20.1561 14.18 20.5649 15.0513C20.8361 15.6288 21.0374 15.75 21.6749 15.75H24.2673C25.5773 15.75 25.9336 15.43 25.3498 14.2C24.6901 12.8206 23.7561 11.5901 22.6048 10.5838C21.8099 9.90005 21.4136 9.5588 21.3924 9.3063C21.3686 9.05506 21.6599 8.69881 22.2424 7.98632C23.3673 6.60883 24.8998 4.4476 25.6148 2.15386C25.9698 1.01637 25.6361 0.750126 24.4848 0.750126H22.1561C21.0274 0.750126 21.0286 0.711377 20.7624 1.99137C20.3299 4.0676 18.9149 6.06383 17.5849 7.42257C16.9536 8.06757 16.5724 8.45631 16.1786 8.29756C15.7849 8.13881 15.7499 7.65632 15.7499 6.68633Z" />
                    </svg>
                </a>
            </div>
            <div class="footer__menu">
                <menu>
                    <li v-for="item in menu" :key="item.id">
                        <router-link :to="'/'+item.link"> 
                            {{ item.label }}
                        </router-link>
                    </li>
                </menu>
            </div>
            <div class="footer__bottom">
                <button @click="()=>{this.showSightless=!this.showSightless ;this.$emit('sightless',this.showSightless,) }">Версия для слабовидящих</button>
                <a target="_blank" href="https://mosp51.ru/files/doc/Политика_в_отношении_обработки_и_защиты_ПДн.pdf">
                    Политика обработки и защиты персональных данных
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default{
    mounted(){
            axios
            .get('https://mosp51.ru/api/menu/footer')
            .then(response=>{
                this.menu = response.data
            })
        
    },
    data(){
        return{
            menu:[],
            showSightless:false,
        }
    }
}
</script>
<style>
.footer{
    background-color: #EDF6FF;
    box-shadow:0 0 40px 0 #EEEEEE66, 5px -5px 5px 0 #E5EDF5E5;
    padding-top: 64px;
    background-image: url(../assets/Vector1.svg),url(../assets/Vector2.svg);
    background-position: left center, right center;
    background-repeat: no-repeat;
}
.footer .footer__bottom,
.footer .footer__top {
    display: flex;
    justify-content: space-between;
}
.footer .footer__top a{
    height: 24px;
    stroke:#175472;
}
.footer .footer__top button:hover{
    color:#007BB8;
    fill: #007BB8;
}
.footer .footer__top a:hover{
    stroke:#007BB8;
}
.footer .footer__bottom{
    padding-bottom: 64px;
}
.footer .footer__menu{
    padding:59px  0 ;
}
.footer .footer__menu menu{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap:32px;
    margin: 0;
    padding: 0;
}
.footer .footer__menu menu li{
    list-style-type: none;
}
.footer .footer__menu menu li a{
    text-decoration: none;
    font-size: 16px;
    color: #0D3041;
    font-weight: 501;
}
.footer .footer__menu menu li a:hover{
    color: #007BB8 ;
}
.footer__bottom a,
.footer__bottom button{
    font-size: 14px;
    color: #0D3041;
    text-decoration: underline;
    border: none;
    background-color: transparent;
    padding: 0;
    cursor: pointer;
}
.footer__bottom a:hover,
.footer__bottom button:hover{
    color: #007BB8 ;
}
@media (max-width: 1000px){
    .footer .footer__menu menu{
        display: flex;
        flex-direction: column;
    }
    .footer .footer__top a ,
    .footer .footer__top a svg{
       height: 15px;
    }
    .footer .footer__menu{
        padding:49px 0
    }
    .footer{
        padding-top:49px;
        background-image: url(../assets/Vector1.svg),url(../assets/Vector1.svg),url(../assets/Vector2.svg),url(../assets/Vector2.svg);
        background-position: -80% 45px,  -80% calc(100% - 82px), 180% 45px, 180% calc(100% - 82px);
        background-size: auto 87px;
        background-repeat: no-repeat;
    }

    .footer .footer__bottom{
        justify-content: start;
        flex-direction: column;
        gap: 16px;
        padding-bottom: 46px;
    }
    .footer .footer__bottom>*{
        text-align: start;
    }
    
}
</style>
